import React from "react";
import "./style.scss";

const Loader = ({ isFullPage = false, isPopOver = false }) => {
  const loaderClass = isFullPage
    ? `loader-backdrop ${isPopOver && "popover"}`
    : "loader-container";
  const imgClass = `loader-gif ${isFullPage && "full-screen"}`;

  return (
    <div className={loaderClass}>
      <img src="/images/loader.gif" alt="Loading..." className={imgClass} />
    </div>
  );
};

export default Loader;
